import { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";

export default function RequestForm() {
  const [devices, setDevices] = useState([]);
  const [datasets, setDatasets] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [selectedDataset, setSelectedDataset] = useState(null);
  const [requestType, setRequestType] = useState("");
  const [startIndex, setStartIndex] = useState("");
  const [endIndex, setEndIndex] = useState("");
  const [networkScore, setNetworkScore] = useState(0);
  const [message, setMessage] = useState("");

  useEffect(() => {
    axios.get("/api/devices")
      .then((response) => setDevices(response.data))
      .catch((error) => console.error("Error fetching devices:", error));
  }, []);

  useEffect(() => {
    // Reset the dataset selection when device changes
    setSelectedDataset(null); // Reset dataset when device changes
    if (selectedDevice) {
      //setDatasets([]); // Clear datasets if no device is selected
      //setSelectedDataset(null); // Reset selected dataset when a new device is selected
      axios.get(`/api/datasets?device_id=${selectedDevice.value}`)
        .then((response) => setDatasets(response.data))
        .catch((error) => console.error("Error fetching datasets:", error));
    } else {
      setDatasets([]); // Clear datasets if no device is selected
      setSelectedDataset(null);
    }
  }, [selectedDevice]);
  
  const requestOptions = [
    { value: "all_raw", label: "All Raw Images" },
    { value: "range_raw", label: "Range of Raw Images" },
    { value: "processed", label: "Processed Data" },
    { value: "network_objects", label: "Network Objects" }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedDevice || !selectedDataset || !requestType) {
      setMessage("Please fill all fields.");
      return;
    }

    try {
      const response = await axios.post("/api/submit_request", {
        device_id: selectedDevice.value,
        dataset_id: selectedDataset.value,
        request_type: requestType,
        start_index : requestType === "range_raw" ? startIndex : null,
        end_index: requestType === "range_raw" ? endIndex : null,
        network_score: requestType === "network_objects" ? networkScore : null
      });

      setMessage("Request submitted successfully!");
    } catch (error) {
      setMessage("Error submitting request.");
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-semibold mb-4">Request Data</h2>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="block text-gray-700">Select Device</label>
          <Select options={devices.map(d => ({ value: d.id, label: d.device_name }))} onChange={setSelectedDevice} />
        </div>

        <div className="mb-3">
          <label className="block text-gray-700">Select Dataset</label>
          <Select options={datasets.map(ds => ({ value: ds.id, label: ds.dataset_name }))} onChange={setSelectedDataset} />
        </div>

        <div className="mb-3">
          <label className="block text-gray-700">Request Type</label>
          <Select options={requestOptions} onChange={(option) => setRequestType(option.value)} />
        </div>

        {requestType === "range_raw" && (
          <div>
            <label className="block text-gray-700">Start Index</label>
            <input type="number" className="w-full p-2 border rounded" value={startIndex} onChange={(e) => setStartIndex(Number(e.target.value))}/>

            <label className="block text-gray-700 mt-2">End Index</label>
            <input type="number" className="w-full p-2 border rounded" value={endIndex} onChange={(e) => setEndIndex(Number(e.target.value))}/>
          </div>

        )}

        {requestType === "network_objects" && (
          <>
            <label className="block text-gray-700 mt-2">Network Confidence Threshold (0 to 1)</label>
            <input
              type="number"
              min="0"
              max="1"
              step="0.01"
              className="w-full p-2 border rounded"
              value={networkScore}
              onChange={(e) => setNetworkScore(Number(e.target.value))}
            />
          </>
        )}

        <button type="submit" className="mt-4 w-full bg-blue-600 text-white py-2 rounded">
          Submit Request
        </button>

        {message && <p className="mt-3 text-center text-gray-700">{message}</p>}
      </form>
    </div>
  );
}
